export function V2Empty({ message = 'Nothing here yet.' }) {
  return (
    <div className="v2-empty" data-testid="v2-empty">
      <span className="v2-empty-text">{message}</span>
    </div>
  );
}
